// extracted by mini-css-extract-plugin
module.exports = {"dpuDetailD":"D_dpuDetailD__NUIyP"};